// utils/helperFunctions/isSimpleCheckUser.js
import { getSimpleCheckAllowedEmails } from "./getSimpleCheckUserList";

export const isSimpleCheckUser = async (userEmail) => {
    if (!userEmail) return false;
    const allowedEmails = await getSimpleCheckAllowedEmails();
    const normalizedEmail = userEmail.toLowerCase().trim();
    const normalizedAllowedEmails = allowedEmails.map((e) =>
        (e || "").toLowerCase().trim(),
    );
    return normalizedAllowedEmails.includes(normalizedEmail);
}
